<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-end text-secondary pb-2">Ajout d'un document</h3>
  </div>
  @if (documentDetailsForm) {
    <form [formGroup]="documentDetailsForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="row">
          <div class="mb-3 text-secondary col-12">
            <small class="form-text text-secondary">Les champs marqués d'un * sont obligatoires. </small>
          </div>
          <!-- Titre et nom de fichier -->
          <div class="mb-3 col-12">
            <label class="text-secondary required">Titre</label>
            <select class="form-select" formControlName="title" [class.is-invalid]="submitted && documentDetailsForm.controls.title.invalid">
              @if (!documentDetailsForm.value.title) {
                <option [ngValue]="" selected hidden></option>
              }
              @for (title of titles; track title) {
                <option [ngValue]="title.id">
                  {{ title.label }}
                </option>
              }
            </select>
            @if (submitted && documentDetailsForm.controls?.title?.errors?.required) {
              <small class="form-text text-danger">Le titre est requis.</small>
            }
          </div>
          <div class="mb-3 col-12 text-secondary">
            <label class="required">Fichier</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                readonly="true"
                [class.is-invalid]="submitted && documentDetailsForm.controls.fileName.invalid"
                formControlName="fileName"
                />
              <label class="btn btn-secondary input-group-text">
                <span class="cursor-pointer">
                  Parcourir...
                  <input (change)="onFileChange($event)" type="file" style="display: none" /></span
                ></label>
              </div>
              @if (submitted && documentDetailsForm.controls?.fileName?.errors?.required) {
                <small class="form-text text-danger"
                  >Le document est requis.</small
                  >
                }
                @if (submitted && documentDetailsForm.controls?.fileName?.errors?.allowedType) {
                  <small class="form-text text-danger"
                    >Le type du fichier est invalide (jpg, png et pdf seulement).</small
                    >
                  }
                </div>
              </div>
            </div>
            <!-- Boutons actions -->
            <div class="row px-3">
              <div class="col-6 col-md-12 col-lg-6 mb-1"></div>
              <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
                <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
                  <fa-icon icon="ban"></fa-icon>
                  <span class="ms-3 d-none d-md-block">Annuler</span>
                </button>
              </div>
              <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
                <button
                  *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+']"
                  class="btn btn-primary d-flex justify-content-center"
                  type="submit"
                  >
                  <fa-icon icon="save"></fa-icon>
                  <span class="ms-3 d-none d-md-block">Sauvegarder</span>
                </button>
              </div>
            </div>
          </form>
        }
      </div>
